import { useCanViewAllocations } from "@/services/AuthService";
import { Navigate } from "react-router-dom";

interface RequireAllocationsAccessProps {
  children: React.ReactNode;
}

export function RequireAllocationsAccess({ children }: RequireAllocationsAccessProps) {
  const canView = useCanViewAllocations();
  if (!canView) return <Navigate to="/pipeline" replace />;
  return <>{children}</>;
}
